export default {
  shipmentAmount(state) {
    const { shipment_amount = {} } = state.ordersPerState;

    return shipment_amount;
  },
  totalAmountOfVolumes(state) {
    const { total_amount_of_volumes = 0 } = state.ordersPerState;

    return total_amount_of_volumes;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-map/store/getters.js